<template>
    <div class="container mx-md-5 pb-4">
        <h5 class="text-white mt-4">
            Projects
            <small class="float-right">
                <a target="_blank" class="text-white border-bottom"
                    href="https://raw.githubusercontent.com/ShineShineDev/ShineShineDev/refs/heads/main/data.json">
                    Json File
                </a>
            </small>
        </h5>
        <div class="shine-divider"></div>
        <div v-if="loadingStatus" class="mt-3">
            <Pending />
        </div>

        <div class="modal fade bd-example-modal-lg" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel"
            aria-hidden="true">
            <div class="modal-dialog modal-lg" style="min-width:90%;">
                <div class="modal-content">
                    <div class="modal-content" id="modal-image">
                        <div class="d-flex justify-content-end py-2">
                            <button @click="zoomIn()" type="button" class="btn btn-sm bg-white">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                    class="bi bi-zoom-in" viewBox="0 0 16 16">
                                    <path fill-rule="evenodd"
                                        d="M6.5 12a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11M13 6.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0" />
                                    <path
                                        d="M10.344 11.742q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1 6.5 6.5 0 0 1-1.398 1.4z" />
                                    <path fill-rule="evenodd"
                                        d="M6.5 3a.5.5 0 0 1 .5.5V6h2.5a.5.5 0 0 1 0 1H7v2.5a.5.5 0 0 1-1 0V7H3.5a.5.5 0 0 1 0-1H6V3.5a.5.5 0 0 1 .5-.5" />
                                </svg>
                            </button>
                            <button @click="zoomOut()" type="button" class="btn btn-sm bg-white">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                    class="bi bi-zoom-out" viewBox="0 0 16 16">
                                    <path fill-rule="evenodd"
                                        d="M6.5 12a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11M13 6.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0" />
                                    <path
                                        d="M10.344 11.742q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1 6.5 6.5 0 0 1-1.398 1.4z" />
                                    <path fill-rule="evenodd"
                                        d="M3 6.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5" />
                                </svg>
                            </button>
                            <button @click="fullScreen()" type="button" class="btn btn-sm bg-white">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                    class="bi bi-fullscreen" viewBox="0 0 16 16">
                                    <path
                                        d="M1.5 1a.5.5 0 0 0-.5.5v4a.5.5 0 0 1-1 0v-4A1.5 1.5 0 0 1 1.5 0h4a.5.5 0 0 1 0 1zM10 .5a.5.5 0 0 1 .5-.5h4A1.5 1.5 0 0 1 16 1.5v4a.5.5 0 0 1-1 0v-4a.5.5 0 0 0-.5-.5h-4a.5.5 0 0 1-.5-.5M.5 10a.5.5 0 0 1 .5.5v4a.5.5 0 0 0 .5.5h4a.5.5 0 0 1 0 1h-4A1.5 1.5 0 0 1 0 14.5v-4a.5.5 0 0 1 .5-.5m15 0a.5.5 0 0 1 .5.5v4a1.5 1.5 0 0 1-1.5 1.5h-4a.5.5 0 0 1 0-1h4a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 1 .5-.5" />
                                </svg>
                            </button>
                            <button type="button" class="btn btn-sm bg-white mr-2" @click="closeModal">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                    class="bi bi-x-circle" viewBox="0 0 16 16">
                                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                                    <path
                                        d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
                                </svg>
                            </button>
                        </div>
                        <div class="modal-body p-1 mb-3">
                            <div class="d-flex justify-content-between pb-3">
                                <button @click="previous()" class="btn btn-sm bg-white"
                                    click="changeCurrentViewImg(currentIndex,'arrow','back')">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                        class="bi bi-arrow-left" viewBox="0 0 16 16">
                                        <path fill-rule="evenodd"
                                            d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8" />
                                    </svg>
                                </button>
                                <div v-if="currentModalActiveImage != null">
                                    <img :src="`${currentModalActiveImage.depend}${currentModalActiveImage.url}`"
                                        style="height:400px;z-index: 10000;"
                                        :style="{ transform: `scale(${zoomLevel})` }" class="img-fluid rounded mt-1">
                                </div>

                                <button @click="next()" class="btn btn-sm bg-white"
                                    click="changeCurrentViewImg(currentIndex,'arrow','forward')">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                        class="bi bi-arrow-right" viewBox="0 0 16 16">
                                        <path fill-rule="evenodd"
                                            d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                                    </svg>
                                </button>
                            </div>
                            <div class="d-flex justify-content-center mt-2" style="gap: 5px;">
                                <div v-for="(img, photoIndex) of modalImgs">
                                    <div :class="{ 'active-scale': photoIndex === currentPhotoIndex }"
                                        @click="changeCurrentPhotoIndex(photoIndex)" class="img-fluid border rounded"
                                        style="width:50px; height: 50px; background-size: cover; background-position: center;"
                                        :style="`background-image: url(${img.depend}${img.url})`"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="mx-4 mt-2">
            <div class="row " v-if="!loadingStatus">
                <div v-for="(project, index) in projects" :key="index"
                    class="col-md-8 p-3 mt-md-3  mt-3 rounded border-line" style="background-color: #32383D;">
                    <div style="color: #FEC0CA;font-family: serif;">
                        <p class="mb-1 d-flex align-self-center"><b style="color: #FEC0CA;font-family: serif;">
                                <img v-if="project.logo_url != null" :src="`${project.logo_url}`" style="height:30px;"
                                    class="img-fluid rounded">
                                {{ project.name }}</b>
                        </p>
                        &nbsp;Associated with {{ project.associated }}
                        <div class="mb-2 mt-3"><i>Key RSesponsibilities included : </i></div>
                        <p class="d-inline" style="font-family: serif;" v-html="getDisplayText(project, index)"></p>
                        <a href="#" @click.prevent="toggleExpand(index)" class="text-white" style="font-size: 15px;">
                            {{ expandedProjects[index] ? 'See less' : 'See more' }}
                        </a>
                        <div class="d-flex my-3" style="gap: 5px;flex-wrap: wrap;">
                            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" fill="currentColor"
                                class="bi bi-gem mt-1" viewBox="0 0 16 16">
                                <path
                                    d="M3.1.7a.5.5 0 0 1 .4-.2h9a.5.5 0 0 1 .4.2l2.976 3.974c.149.185.156.45.01.644L8.4 15.3a.5.5 0 0 1-.8 0L.1 5.3a.5.5 0 0 1 0-.6zm11.386 3.785-1.806-2.41-.776 2.413zm-3.633.004.961-2.989H4.186l.963 2.995zM5.47 5.495 8 13.366l2.532-7.876zm-1.371-.999-.78-2.422-1.818 2.425zM1.499 5.5l5.113 6.817-2.192-6.82zm7.889 6.817 5.123-6.83-2.928.002z" />
                            </svg>
                            <div v-for="(lang) of project.used" style="font-family: serif;font-size: 14px;">
                                {{ lang }} |
                            </div>
                        </div>
                        <div>
                            <div class="d-flex d-inline" style="gap: 0px 10px;flex-wrap: wrap;font-size: 14px;">
                                <span style="font-family: serif;"> Link : </span>
                                <a style="font-family: serif;" class="border-bottom text-white" :href="`${link.url}`"
                                    target="_blank" v-for="(link, index) of project.urls">{{ link.desc }}</a>
                            </div>
                        </div>
                        <div class="d-flex mt-3" style="gap: 10px;flex-wrap: wrap;">
                            <div v-for="(img, photoIndex) in project.images">
                                <div class="card bg-dark rounded p-2" @click="shwoPhoto(index, photoIndex)">
                                    <div class="img-fluid"
                                        style="width: 100px; height: 100px; background-size: cover; background-position: center;"
                                        :style="`background-image: url(${img.depend}${img.url})`"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div style="position: relative;border-radius:10px">
                    <span class="badge text-dark px-2 p-1 rounded mt-2 ml-2 border"
                        style="position: absolute;background-color: rgba(255, 255, 255,0.9);">
                        {{project.type}}
                    </span>
                    <div class="card__arrow px-3">
                        <a :href="project.url" target="_blank" style="cursor: pointer" class="text-white">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                class="bi bi-arrow-right" viewBox="0 0 16 16">
                                <path fill-rule="evenodd"
                                    d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                            </svg>
                        </a>
                    </div>
                    <img style="width: 100%; height: 200px;border-radius: 10px 10px 0px 0px;" :src="project.img_url">
                    <div class="bg-white w-100 py-2 pl-3 border"
                        style="position: absolute;border-radius: 10px;bottom:-40px">
                        <a :href="project.url" target="_blank" style="cursor: pointer" class="text-dark">
                            <div class="d-flex align-items-center" style="gap:10px">
                                <img class="bg-dark"
                                    style="width: 40px; height: 40px; border-radius: 50%; object-fit: contain;"
                                    :src="project.logo_url" alt="Project Logo">
                                <h6 class="mt-2">{{project.name}}</h6>
                            </div>
                            <div class="pt-1 pb-1">
                                <span v-for="item in project.used" :key="item.id" class="badge text-white mr-1"
                                    style="background-color: #df8218;">
                                    {{item}}
                                </span>
                            </div>
                        </a>
                    </div>
                </div> -->
                </div>
            </div>
        </div>
        <img src="https://raw.githubusercontent.com/ShineShineDev/ShineShineDev/55f9002887e4a0cbb513502045b1734b2f2fbe67/imgs/mainIconsdark.svg"
            class="js-img" />
    </div>
</template>
<script>
import Pending from "./../components/Pending.vue";
import {InitBrowserAgent} from "./../services/detech-visitors.js";
// import { mapState, mapActions } from 'vuex';

export default {
    name: "Project",
    data() {
        return {
            loadingStatus: true,
            projects: [],
            expandedProjects: {},
            host: process.env.VUE_APP_HOST,
            modalImgs: [],
            currentModalActiveImage: null,
            currentPhotoIndex: null,
            zoomLevel: 1
        };
    },
    components: {
        Pending,
    },
    created() {
        const {browser,language,platform,innerWidth,innerHeight,URL,visitor_generated__id,is_new_visitor,outerWidth,outerHeight,referrer} = InitBrowserAgent(); 
        this.$store.dispatch('initApi', { url: 'https://bot.okjapanstore.com/api/tg/notify', method: 'POST', data: { Noti: 'Alert',URL,browser,language,platform,innerWidth,innerHeight,visitor_generated__id , is_new_visitor,innerWidth,innerHeight,outerWidth,outerHeight,referrer} });
        fetch('https://raw.githubusercontent.com/ShineShineDev/ShineShineDev/refs/heads/main/data.json')
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then(data => {
                this.projects = data;
                this.loadingStatus = false
            })
            .catch(error => {
                console.error('There was a problem with the fetch operation:', error);
            });
    },
    // computed: {
    //     ...mapState(['data', 'err_status', 'pending_status']), // Assuming 'posts', 'err_status', 'pending_status' are in your root state
    //     error() {
    //         return this.err_status;
    //     },
    //     pending() {
    //         return this.pending_status;
    //     }
    // },
    methods: {
        toggleExpand(index) {
            this.$set(this.expandedProjects, index, !this.expandedProjects[index]);
        },
        getDisplayText(project, index) {
            const html = project.lists || '';
            if (this.expandedProjects[index]) {
                return html;
            }
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = html;
            const textOnly = tempDiv.textContent || tempDiv.innerText || '';
            return textOnly.length > 150
                ? textOnly.substring(0, 150) + '...'
                : textOnly;
        },
        shwoPhoto(projectIndex, photoIndex) {
            this.modalImgs = this.projects[projectIndex].images;
            this.currentPhotoIndex = photoIndex;
            this.currentModalActiveImage = this.modalImgs[this.currentPhotoIndex];
            $('.bd-example-modal-lg').modal('show');
        },
        next() {
            if (this.currentPhotoIndex < this.modalImgs.length - 1) {
                this.currentPhotoIndex++;
            } else {
                this.currentPhotoIndex = 0;
            }
            this.currentModalActiveImage = this.modalImgs[this.currentPhotoIndex];
        },
        previous() {
            if (this.currentPhotoIndex > 0) {
                this.currentPhotoIndex--;
            } else {
                this.currentPhotoIndex = this.modalImgs.length - 1;
            }
            this.currentModalActiveImage = this.modalImgs[this.currentPhotoIndex];
        },
        changeCurrentPhotoIndex(index) {
            this.currentModalActiveImage = this.modalImgs[index];
            this.currentPhotoIndex = index;
        },
        zoomIn() {
            this.zoomLevel += 0.1;
        },
        zoomOut() {
            if (this.zoomLevel > 0.1) {
                this.zoomLevel -= 0.1;
            }
        },
        fullScreen() {
            const imgElement = document.getElementById('modal-image');
            if (!document.fullscreenElement &&
                !document.webkitFullscreenElement &&
                !document.msFullscreenElement) {
                if (imgElement.requestFullscreen) {
                    imgElement.requestFullscreen();
                } else if (imgElement.webkitRequestFullscreen) {
                    imgElement.webkitRequestFullscreen();
                } else if (imgElement.msRequestFullscreen) {
                    imgElement.msRequestFullscreen();
                }
            } else {
                if (document.exitFullscreen) {
                    document.exitFullscreen();
                } else if (document.webkitExitFullscreen) {
                    document.webkitExitFullscreen();
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen();
                }
            }
        },
        closeModal() {
            $('.bd-example-modal-lg').modal('hide');
        }
    }
};
</script>

<style scoped>
.active-scale {
    transform: scale(1.2);
    transition: transform 0.3s ease-in-out;
    margin: 0 7px 0 7px;
    /* box-shadow: 0 0 10px rgba(255, 255, 255, 0.6); */
}

.border-line {
    border-radius: 50%;
    border-bottom: 2px solid #FF4A01;

    border-radius: 0 0 20px 20px;
}

.card__arc path {
    top: 0;
    fill: white;
    d: path("M 40 80 c 22 0 40 -22 40 -40 v 40 Z");
}

.card__arrow {
    position: absolute;
    background: #df8218;
    border-radius: 0px 30px 0px 100px;
    right: 0;
    font-size: 19px;
    color: white;
    transition: 0.2s;
}

.shine-divider {
    margin-top: 5px;
    margin-bottom: 3px;
    border: 0px;
    height: 3px;
    background: linear-gradient(to right, rgba(157, 157, 157, 0), #ec4e10, rgba(0, 0, 0, 0));
    background-size: 200% 100%;
    animation: shineAnimation 1.5s infinite alternate;
}

@keyframes shineAnimation {
    0% {
        background-position: 100% 50%;
    }

    100% {
        background-position: 0 50%;
    }
}

.js-img {
    position: fixed;
    bottom: 0%;
    left: 80%;

    width: 400px;

}
</style>